import React, { useContext, useReducer } from "react";
import axios from "../../axiosinstance";
import CloudinaryContext from "./CloudinaryContext";
import CloudinaryReducer from "./CloudinaryReducer";
import {
  CLOUDINARY_BROWSE_LOADING,
  CLOUDINARY_IMAGES,
} from "../types";

// Contexts
import LayoutContext from "../layout/LayoutContext";

const CloudinaryState = (props) => {
  const initialState = {
    browse_loading: false,
    images: null,
    image_next_cursor: null,
  };

  const [state, dispatch] = useReducer(CloudinaryReducer, initialState);
  const { setLoading, setAlert } = useContext(LayoutContext);

  const uploadImage = async (images) => {
    setLoading(true);

    try {
      const res = await axios.post("/api/parameters/avatar", { avatars: images });
      setAlert("Avatar uploaded successfully", "success");
      // retrieve latest
      browseImage(false);
    } catch (err) {
      console.log(err.response.data);
      setAlert("Avatar upload failed", "error");
    }

    setLoading(false);
  };

  const deleteAvatar = async (public_id) => {
    setLoading(true);

    try {
      const res = await axios.post("/api/parameters/deleteAvatar", { public_id });
      setAlert("Avatar deleted successfully", "success");
      // retrieve latest
      browseImage(false);
    } catch (err) {
      console.log(err.response.data);
      setAlert("Avatar deletion failed", "error");
    }

    setLoading(false);
  }

  const browseImage = async (load_more) => {
    try {
      if (load_more && state.image_next_cursor !== null) {
        dispatch({
          type: CLOUDINARY_BROWSE_LOADING,
          payload: true,
        });
      }

      let res = await axios.get(`/api/parameters/avatar`);

      dispatch({
        type: CLOUDINARY_IMAGES,
        payload: res.data,
      });
    } catch (err) {
      console.log(err.response.data);
      setAlert("Image browse failed", "error");
    }

    dispatch({
      type: CLOUDINARY_BROWSE_LOADING,
      payload: false,
    });
  };

  return (
    <CloudinaryContext.Provider
      value={{
        browse_loading: state.browse_loading,
        images: state.images,
        image_next_cursor: state.image_next_cursor,

        deleteAvatar,
        browseImage,
        uploadImage
      }}
    >
      {props.children}
    </CloudinaryContext.Provider>
  );
};

export default CloudinaryState;
